import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/r/$token")({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: "/review-heallexa",
      search: { token: params.token },
    });
  },
});
